import React from "react"
import PropTypes from "prop-types"
import Button from "@material-ui/core/Button"

import { withMutation } from "store/Mutation"

class ResetButton extends React.Component {
  static propTypes = { mutation: PropTypes.object }

  _handleClick = e => {
    e.preventDefault()
    this.props.mutation.reset()
  }

  render() {
    const { mutation, ...otherProps } = this.props

    return <Button disabled={mutation.isSubmitting()} onClick={this._handleClick} {...otherProps} />
  }
}

export default withMutation()(ResetButton)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-Form/ResetButton.js